import { Button, Flex, useClipboard, useToast } from "@chakra-ui/react";
import { ShareIcon } from "@src/icons";
import { useEffect } from "react";

export interface ProductButtonsProps {
  purchaseLink?: string;
}

export const ProductButtons = (props: ProductButtonsProps) => {
  const { onCopy, hasCopied } = useClipboard(globalThis?.window?.location?.href);
  const toast = useToast();

  useEffect(() => {
    if (hasCopied) {
      toast({
        description: "Link copiado com sucesso!",
        status: "success",
        isClosable: true,
        position: "top-right",
        duration: 1500,
      });
    }
  }, [hasCopied]);

  return (
    <Flex
      width={"full"}
      flexDirection={{ base: "column", md: "row" }}
      justify={"center"}
      gridGap={{ base: "0.8rem", md: "1.5rem" }}
    >
      {props.purchaseLink && (
        <Button
          as="a"
          href={props.purchaseLink}
          target="_blank"
          variant="solid"
          colorScheme={"primary"}
          width={{ base: "full", md: "17.3125rem" }}
          height={{ base: "3rem", md: "3.375rem" }}
          fontSize={"1rem"}
        >
          Comprar online
        </Button>
      )}
      <Button
        variant="outline"
        colorScheme={"primary"}
        leftIcon={<ShareIcon />}
        width={{ base: "full", md: "17.3125rem" }}
        height={{ base: "3rem", md: "3.375rem" }}
        fontSize={"1rem"}
        onClick={onCopy}
        isDisabled={hasCopied}
      >
        Compartilhar
      </Button>
    </Flex>
  );
};
